import { cmsAxiosInstanceWithoutHeaders } from 'api/axiosClient'
import { CMS_ACCESS_TOKEN } from 'constants/process'
import { getPageSEO } from 'helpers/seo'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'

import dynamic from 'next/dynamic'

const BlogPage = dynamic(() =>
  import('containers/BlogPage').then((res) => res.BlogPage)
)

export default withAuth(BlogPage, {
  LoggedOutComponent: BlogPage,
  naiveCheck: true,
})

const fetchBlogData = async (context, user) => {
  const SEO = getPageSEO('blog')
  try {
    const [articlesRes, videosRes] = await Promise.all([
      cmsAxiosInstanceWithoutHeaders.get('articles?populate=image_url', {
        headers: {
          Authorization: `Bearer ${CMS_ACCESS_TOKEN}`,
        },
      }),
      cmsAxiosInstanceWithoutHeaders.get('videos?populate=thumbnail', {
        headers: {
          Authorization: `Bearer ${CMS_ACCESS_TOKEN}`,
        },
      }),
    ])

    if (articlesRes.data?.data?.length && videosRes.data?.data?.length) {
      return {
        articles: articlesRes.data.data.map(({ attributes }) => attributes),
        videos: videosRes.data.data.map(({ attributes }) => attributes),
        ...SEO,
      }
    }
    return {
      notFound: true,
    }
  } catch (e) {
    console.error('There was an error fetching the articles: ', e)
    return { notFound: true }
  }
}

export const getStaticProps = withAuthServerSideProps(fetchBlogData)
